import { _js } from '@ifixit/localize';
import { useContext } from 'react';
import styled from 'styled-components';
import { color, fontSize, space } from '@ifixit/primitives';
import { faUser } from '@fortawesome/pro-solid-svg-icons/faUser';
import { FaIcon } from '@ifixit/icons';
import { trackAnalyticsCustomEvent } from '@ifixit/analytics';
import { BreakpointsContext } from 'Shared/utils/breakpoints';

const Text = styled.a`
   font-weight: normal;
   font-size: ${fontSize.md};
   transition: color 0.1s;
   color: ${color.white};

   &:hover {
      color: ${color.brand[400]};
   }
`;

const Container = styled.div`
   position: relative;
   display: flex;
   justify-content: space-between;
   align-items: center;
   gap: ${space[4]};

   ${Text} {
      text-decoration: none;
      white-space: nowrap;
   }
`;

const Divider = styled.div`
   flex-shrink: 0;
   width: 1px;
   height: 24px;
   background: ${color.gray[700]};
`;

const trackLoginClick = () => {
   trackAnalyticsCustomEvent({
      eventCategory: 'Header Auth',
      eventAction: 'Log In Header Button - Click',
   });
};

const trackJoinClick = () => {
   trackAnalyticsCustomEvent({
      eventCategory: 'Header Auth',
      eventAction: 'Join Header Button - Click',
   });
};

const AuthIcons = () => {
   const breakpoints = useContext(BreakpointsContext);

   if (breakpoints.isMobileTablet()) {
      return (
         <Text href="/Login" aria-label="Log in" onClick={trackLoginClick}>
            <FaIcon
               icon={faUser}
               focusable="false"
               color={color.white}
               boxSize={{ base: '20px', sm: '24px' }}
            />
         </Text>
      );
   }

   return (
      <Container>
         <Text href="/Join" id="navSignup" onClick={trackJoinClick}>
            {_js('Join')}
         </Text>
         <Divider />
         <Text href="/Login" id="navLogin" onClick={trackLoginClick}>
            {_js('Log In')}
         </Text>
      </Container>
   );
};

export default AuthIcons;
